// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.add-member-rol-data {
    display: flex;
    margin-right: var(--space-and-half);
    max-width: 70%;
}

.add-member-rol {
    display: flex;
    
}

.add-member-rol__roles {
    box-sizing: border-box;
    border-radius: 2px;
    align-self: center;
    margin-right: var(--space-half);
}

.add-member-rol__roles .MuiSelect-select.MuiSelect-select {
    font-size: var(--space);
    font-family: var(--secondary-font);
}

.add-member-rol__roles .select-field-input {
    background: var(--border-card-color);
    border: 0px;
    height: var(--space-x2);
    border-radius: 4px;
}

.add-member-rol__positions__number {
    box-sizing: border-box;
    border-radius: 2px;
    font-size: var(--space-half-quarter);
    margin-right: var(--space-and-half);
}

.add-member-rol__positions__number .input-field-input {
    font-size: var(--space);
    font-family: var(--secondary-font);
    background-color: var(--border-card-color);
    border: 0px;
    padding: 0;
    max-width: var(--space-x3);
    border-radius: 4px;
    height: var(--space-x2);
    text-align: end;
    min-width: 25px;
}

.add-member-rol__positions__positions {
    box-sizing: border-box;
    border-radius: 2px;
    align-self: center;
    font-size: var(--space-half-quarter);
}

.add-member-rol__positions__positions .select-field-input {
    background:var(--border-card-color);
    border: 0px;
    height: var(--space-x2);
    border-radius: 4px;
}

.add-member-rol__positions__positions .MuiSelect-select.MuiSelect-select {
    padding-right: var(--space-half-quarter);
    font-size: var(--space);
    font-family: var(--secondary-font);
}

.add-member-rol__select-input{
    margin: 0;
}

.add-member-rol__select-input .input-field__tip-message{
    position: fixed;
}

.add-member-rol__select-input .input-field__message.error{
    position: fixed;
}

.select-field.add-member-rol__select-input .MuiInputBase-root.MuiInput-root.MuiInput-underline:before{
    border-bottom: none;
    transition: none;
}

/* Styles to display input arrows */
.add-member-rol__positions__number input::-webkit-outer-spin-button, 
input::-webkit-inner-spin-button { 
    /* opacity: 1; */
    margin-left: var(--space-quarter);
    /* padding-right: var(--space) ; */
} 

.add-member-rol__positions__number input[input_type=number] {
    -moz-appearance: textfield;
}
  `, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-added-member-rol/LeagueAddedMemberRolComponent.styles.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,aAAa;;AAEjB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;IACvB,kCAAkC;AACtC;;AAEA;IACI,oCAAoC;IACpC,WAAW;IACX,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,oCAAoC;IACpC,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;IACvB,kCAAkC;IAClC,0CAA0C;IAC1C,WAAW;IACX,UAAU;IACV,0BAA0B;IAC1B,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;IACnC,WAAW;IACX,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,uBAAuB;IACvB,kCAAkC;AACtC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,mCAAmC;AACnC;;IAEI,gBAAgB;IAChB,iCAAiC;IACjC,kCAAkC;AACtC;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":["\n.add-member-rol-data {\n    display: flex;\n    margin-right: var(--space-and-half);\n    max-width: 70%;\n}\n\n.add-member-rol {\n    display: flex;\n    \n}\n\n.add-member-rol__roles {\n    box-sizing: border-box;\n    border-radius: 2px;\n    align-self: center;\n    margin-right: var(--space-half);\n}\n\n.add-member-rol__roles .MuiSelect-select.MuiSelect-select {\n    font-size: var(--space);\n    font-family: var(--secondary-font);\n}\n\n.add-member-rol__roles .select-field-input {\n    background: var(--border-card-color);\n    border: 0px;\n    height: var(--space-x2);\n    border-radius: 4px;\n}\n\n.add-member-rol__positions__number {\n    box-sizing: border-box;\n    border-radius: 2px;\n    font-size: var(--space-half-quarter);\n    margin-right: var(--space-and-half);\n}\n\n.add-member-rol__positions__number .input-field-input {\n    font-size: var(--space);\n    font-family: var(--secondary-font);\n    background-color: var(--border-card-color);\n    border: 0px;\n    padding: 0;\n    max-width: var(--space-x3);\n    border-radius: 4px;\n    height: var(--space-x2);\n    text-align: end;\n    min-width: 25px;\n}\n\n.add-member-rol__positions__positions {\n    box-sizing: border-box;\n    border-radius: 2px;\n    align-self: center;\n    font-size: var(--space-half-quarter);\n}\n\n.add-member-rol__positions__positions .select-field-input {\n    background:var(--border-card-color);\n    border: 0px;\n    height: var(--space-x2);\n    border-radius: 4px;\n}\n\n.add-member-rol__positions__positions .MuiSelect-select.MuiSelect-select {\n    padding-right: var(--space-half-quarter);\n    font-size: var(--space);\n    font-family: var(--secondary-font);\n}\n\n.add-member-rol__select-input{\n    margin: 0;\n}\n\n.add-member-rol__select-input .input-field__tip-message{\n    position: fixed;\n}\n\n.add-member-rol__select-input .input-field__message.error{\n    position: fixed;\n}\n\n.select-field.add-member-rol__select-input .MuiInputBase-root.MuiInput-root.MuiInput-underline:before{\n    border-bottom: none;\n    transition: none;\n}\n\n/* Styles to display input arrows */\n.add-member-rol__positions__number input::-webkit-outer-spin-button, \ninput::-webkit-inner-spin-button { \n    /* opacity: 1; */\n    margin-left: var(--space-quarter);\n    /* padding-right: var(--space) ; */\n} \n\n.add-member-rol__positions__number input[input_type=number] {\n    -moz-appearance: textfield;\n}\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
